import * as React from 'react';
import { ErrorBoundary } from '../../errors/ErrorBoundary';
import { useDevicesStateContext } from '../DevicesStateContext';

export const DeviceAlerts = () => {
    const { deviceAlertError, upload } =  useDevicesStateContext();

    if (deviceAlertError)
        return (<><h2 className="text-primary">Device Notifications</h2>
            <div className="alert alert-danger">{deviceAlertError}</div>
        </>);

    if (upload.notifications.length > 0) {
        return (
            <div>
                <ErrorBoundary>
                    <h2 className="text-primary">Device Notifications</h2>
                    <p style={{ marginBottom: 15 + 'px' }} className="text-muted">The following notifications were identified on the device:</p>
                    {
                        upload.notifications.map(x => {
                            return <div key={x.id + x.originatingIdentifier} className="alert alert-warning">{x.headline}</div>
                        })
                    }
                </ErrorBoundary>
            </div>
        );
    } else {
        return null;
    }
}
